import { jsx } from "react/jsx-runtime";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './Table.css';import '../Grid/Grid.css';/* empty css                */
/* empty css           */
const Table = ({
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  gutter,
  align,
  justify,
  itemKey,
  items,
  children,
  className
}) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-table", className), children: /* @__PURE__ */ jsx(Row, { gutter, justify, align, children: items.map((item) => /* @__PURE__ */ jsx(Col, { xs, sm, md, lg, xl, xxl, children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-table__item"), children: children(item) }) }, item == null ? void 0 : item[itemKey])) }) });
};
export {
  Table as default
};
//# sourceMappingURL=Table.js.map
